import IObservation, { EProcessingMarkingPublicity, TClassificationText } from '../../interfaces/IObservation';
import IFormType from '../../interfaces/IFormType';
import SGUser from '../../interfaces/IHavainnotUser';
import { IUser } from '../../../../sg-auth/models/User';
import { IFormSchema } from '@/@auditoinnit/auditoinnit/interfaces/IFormSchema';

export const requestObservation = "REQUEST_FETCH_OBSERVATION";
const successFetchObservation = "SUCCESS_FETCH_OBSERVATION";
const failureFetchObservation = "FAILURE_FETCH_OBSERVATION";

const newObservationFormDataUpdate = "NEW_OBSERVATION_FORM_DATA_UPDATE";
const initializeNewObservationForm = "INITIALIZE_NEW_OBSERVATION_FORM";

export const requestCreateObservation = "REQUEST_FETCH_CREATE_OBSERVATION";
const successFetchCreateObservation = "SUCCESS_FETCH_CREATE_OBSERVATION";
const failureFetchCreateObservation = "FAILURE_FETCH_CREATE_OBSERVATION";
const clearCreateObservation = "CLEAR_OBSERVATION_CREATE_OBSERVATION";

const initializeObservationProcessForm = "INITIALIZE_OBSERVATION_PROCESS_FORM";
const observationProcessFormDataUpdate = "OBSERVATION_PROCESS_FORM_DATA_UPDATE";
const clearObservationProcessForm = "CLEAR_OBSERVATION_PROCESS_FORM";

export const requestSaveObservationProcessForm = "REQUEST_FETCH_SAVE_OBSERVATION_PROCESS_FORM";
const successFetchSaveObservationProcessForm = "SUCCESS_FETCH_SAVE_OBSERVATION_PROCESS_FORM";
const failureFetchSaveObservationProcessForm = "FAILURE_FETCH_SAVE_OBSERVATION_PROCESS_FORM";


export const requestDelegateObservation = "REQUEST_FETCH_DELEGATE_OBSERVATION";
const successFetchDelegateObservation = "SUCCESS_FETCH_DELEGATE_OBSERVATION";
const failureFetchDelegateObservation = "FAILURE_FETCH_DELEGATE_OBSERVATION";
export const clearObservationDelegation = "CLEAR_OBSERVATION_DELEGATION";




// DELEGATE OBSERVATION
export interface IRequestDelegateObservation {
    type: typeof requestDelegateObservation;
    payload: { observationGuid: string; user: Pick<IUser, "fullname" | "email" | "id"> }
}

interface ISuccessFetchDelegateObservation {
    type: typeof successFetchDelegateObservation;
    payload: { observationId: number };
}

interface IFailureFetchDelegateObservation {
    type: typeof failureFetchDelegateObservation;
    payload: { error: Error };
}


export interface IClearObservationDelegation {
    type: typeof clearObservationDelegation;
}


// FETCH OBSERVATION
export interface IRequestFetchObservation {
    type: typeof requestObservation;
    payload: { observationGuid: string | number }
}

interface ISuccessFetchObservation {
    type: typeof successFetchObservation;
    payload: { observation: IObservation };
}

interface IFailureFetchObservation {
    type: typeof failureFetchObservation;
    payload: { error: Error };
}

// CREATE OBSERVATION
interface IInitializeNewObservationForm {
    type: typeof initializeNewObservationForm;
    payload: { formType: IFormType, user: SGUser | null, isPublic: boolean };
}

interface INewObservationFormDataUpdate {
    type: typeof newObservationFormDataUpdate;
    payload: { formData: { [key: string]: any }; };
}


// FORM ON PROCESS PHASE
interface IInitializeObservationProcessForm {
    type: typeof initializeObservationProcessForm;
    payload: {
        observation: IObservation;
        userId: number,
        processingMarkingPublicity: EProcessingMarkingPublicity,
        classificationText?: TClassificationText;
    }
}
interface IObservationProcessFormDataUpdate {
    type: typeof observationProcessFormDataUpdate;
    payload: { formData: { [key: string]: any }; };
}
interface IClearObservationProcessForm {
    type: typeof clearObservationProcessForm;
}

export interface IRequestFetchSaveObservationProcessForm {
    type: typeof requestSaveObservationProcessForm;
    payload: { customFormSchema?: IFormSchema; }
}
interface ISuccessFetchSaveObservationProcessForm {
    type: typeof successFetchSaveObservationProcessForm;
    payload: { observation: IObservation };
}
interface IFailureFetchSaveObservationProcessForm {
    type: typeof failureFetchSaveObservationProcessForm;
    payload: { error: Error };
}


export interface IRequestFetchCreateObservation {
    type: typeof requestCreateObservation;

}

interface ISuccessFetchCreateObservation {
    type: typeof successFetchCreateObservation;
    payload: { observation: IObservation };
}

interface IFailureFetchCreateObservation {
    type: typeof failureFetchCreateObservation;
    payload: { error: Error };
}

export interface IClearCreateObservation {
    type: typeof clearCreateObservation;
}






export type IObservationAction
    = IRequestFetchObservation
    | ISuccessFetchObservation
    | IFailureFetchObservation

    | IInitializeNewObservationForm
    | INewObservationFormDataUpdate

    | IRequestFetchCreateObservation
    | ISuccessFetchCreateObservation
    | IFailureFetchCreateObservation
    | IClearCreateObservation

    | IInitializeObservationProcessForm
    | IObservationProcessFormDataUpdate
    | IClearObservationProcessForm
    | IRequestFetchSaveObservationProcessForm
    | ISuccessFetchSaveObservationProcessForm
    | IFailureFetchSaveObservationProcessForm

    | IRequestDelegateObservation
    | ISuccessFetchDelegateObservation
    | IFailureFetchDelegateObservation
    | IClearObservationDelegation

    ;


// FETCH OBSERVATION
export const createRequestFetchObservationAction = (observationGuid: string | number): IRequestFetchObservation => ({
    type: requestObservation,
    payload: { observationGuid }
});

export const createSuccessFetchObservationAction = (observation: IObservation): ISuccessFetchObservation => ({
    type: successFetchObservation,
    payload: { observation }
});

export const createFailureFetchObservationAction = (error: Error): IFailureFetchObservation => ({
    type: failureFetchObservation,
    payload: { error }
});


// CREATE OBSERVATION
export const createInitializeNewObservatioFormAction = (formType: IFormType, user: SGUser | null, isPublic: boolean = true): IInitializeNewObservationForm => ({
    type: initializeNewObservationForm,
    payload: { formType, user, isPublic },
});

export const createNewObservationFormDataUpdateAction = (formData: { [key: string]: any }): INewObservationFormDataUpdate => ({
    type: newObservationFormDataUpdate,
    payload: { formData },
});

export const createRequestFetchCreateObservationAction = (): IRequestFetchCreateObservation => ({
    type: requestCreateObservation,
});

export const createClearCreateObservationAction = (): IClearCreateObservation => ({
    type: clearCreateObservation,
});

export const createSuccessFetchCreateObservationAction = (observation: IObservation): ISuccessFetchCreateObservation => ({
    type: successFetchCreateObservation,
    payload: { observation }
});

export const createFailureFetchCreateObservationAction = (error: Error): IFailureFetchCreateObservation => ({
    type: failureFetchCreateObservation,
    payload: { error }
});


// PROCESS FORM
export const createInitializeObservatioProcessFormAction = (observation: IObservation, userId: number, processingMarkingPublicity: EProcessingMarkingPublicity, classificationText?: TClassificationText): IInitializeObservationProcessForm => ({
    type: initializeObservationProcessForm,
    payload: { observation, userId, processingMarkingPublicity, classificationText }
});
export const createObservationProcessFormDataUpdateAction = (formData: { [key: string]: any }): IObservationProcessFormDataUpdate => ({
    type: observationProcessFormDataUpdate,
    payload: { formData },
});
export const createClearObservationProcessForm = (): IClearObservationProcessForm => ({
    type: clearObservationProcessForm,
});

export const createRequestFetchSaveObservationProcessFormAction = (customFormSchema?: IFormSchema): IRequestFetchSaveObservationProcessForm => ({
    type: requestSaveObservationProcessForm,
    payload: { customFormSchema }
});

export const createSuccessFetchSaveObservationProcessFormAction = (observation: IObservation): ISuccessFetchSaveObservationProcessForm => ({
    type: successFetchSaveObservationProcessForm,
    payload: { observation }
});

export const createFailureFetchSaveObservationProcessFormAction = (error: Error): IFailureFetchSaveObservationProcessForm => ({
    type: failureFetchSaveObservationProcessForm,
    payload: { error }
});


// DELEGATE OBSERVATION
export const createRequestDelegateObservationAction = (user: Pick<IUser, "fullname" | "email" | "id">, observationGuid: string): IRequestDelegateObservation => ({
    type: requestDelegateObservation,
    payload: { observationGuid, user }
});

export const createSuccessFetchDelegateObservationAction = (observationId: number): ISuccessFetchDelegateObservation => ({
    type: successFetchDelegateObservation,
    payload: { observationId }
});

export const createFailureFetchDelegateObservationAction = (error: Error): IFailureFetchDelegateObservation => ({
    type: failureFetchDelegateObservation,
    payload: { error }
});

export const createClearObservationDeleagtionAction = (): IClearObservationDelegation => ({
    type: clearObservationDelegation,
});
